import React, { useState, useEffect } from 'react';
import wp_asa from '../../assets/WP_ASA.webp'
import './herosection.scss';

const HeroSection = ({name, background, height, heightUnit}) => {
	const [calculatedMarginBottom, setCalculatedMarginBottom] = useState(null);

	useEffect(() => {
		const handleResize = () => {
			const heroSection = document.querySelector(".hero-section");
			const heroSectionHeader = document.querySelector(".hero-header");
			const navBar = document.querySelector("nav");
	
			if (heroSection && heroSectionHeader && navBar) {
				const heroSectionHeight = heroSection.offsetHeight;
				const style = window.getComputedStyle(heroSectionHeader);
				const headerFontSize = parseFloat(style.fontSize);
				const navBarHeight = navBar.offsetHeight || 70;
				// const heroWithoutNavHeight = heroSectionHeight - navBarHeight;
	
				setCalculatedMarginBottom(((heroSectionHeight / 2) - (headerFontSize / 2)) - (navBarHeight / 2));
				// console.log(heroWithoutNavHeight)
			} else {
				console.log(heroSection, heroSectionHeader);
			}
		};

		document.addEventListener("DOMContentLoaded", handleResize);
		window.addEventListener("resize", handleResize);

		handleResize();
	
		return () => {
			document.removeEventListener("DOMContentLoaded", handleResize);
			window.removeEventListener("resize", handleResize);
		};
	}, []);	

	return (
		<>
			<div className='hero-section' style={{backgroundImage: background ? `url("${background}")` : `url("${wp_asa}")`, height: `${height ? height : 300}${heightUnit ? heightUnit : 'px'}`}}>
				<h2
					className='hero-header'
					style={{marginBottom: `${calculatedMarginBottom}px`}}
				>
					{name}
				</h2>
			</div>
		</>
	)
}

export default HeroSection;